import { Input } from '@commenda/kakashi';

type CompanyValuationSummaryProps = {
  numberOfShares: number;
  sharePrice: number;
  currency?: {
    name: string;
    style: string;
    countryCode: string;
    decimalPlacesAllowed?: number;
  };
  helpTexts?: {
    mainHeading?: string;
    bodyText?: string;
    connectingText?: string;
  };
};

export const CompanyValuationSummary = ({
  numberOfShares,
  sharePrice,
  currency,
  helpTexts,
}: CompanyValuationSummaryProps) => {
  if (!numberOfShares || !sharePrice) return null;
  return (
    <div className="flex flex-col gap-3 pb-3">
      <div>
        <h3 className="txt-small-medium">
          {helpTexts?.mainHeading || 'Authorized Shares'}
        </h3>
      </div>
      <div className="flex flex-col gap-4">
        <div className="flex items-center gap-4">
          <div className="flex flex-col gap-1 shrink-0 grow">
            <Input
              type="text"
              maxLength={15}
              readOnly
              value={numberOfShares?.toLocaleString()}
            />
          </div>
          <p className="body-15 shrink-0">
            {helpTexts?.connectingText || 'shares valued at'}
          </p>
          <div className="relative shrink-0 grow">
            <div className="flex flex-col gap-1">
              <Input
                className="text-right hide-arrow pl-6"
                type="text"
                name="price"
                id="price"
                value={sharePrice}
              />
            </div>
            <span className="absolute top-1/2 -translate-y-1/2 left-3 select-none touch-none text-neutral-4">
              {currency.style}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
